/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: page description
 * @Date: 2021-10-18 14:44:47
 * @LastEditTime: 2021-10-18 14:48:53
 */
import {createStore,applyMiddleware} from 'redux';
import thunk from 'redux-thunk'
import reducer from 'src/store/reducer';


let store=createStore(reducer,applyMiddleware(thunk))

export default store